module.exports = __webpack_public_path__ + "media/qrcode.0c777566.mp4";